export default __webpack_public_path__ + "static/media/product4.4cbaab79.png";